import React from "react";
import { Link } from "react-router-dom";

const RelatedBlog = ({ blog }) => {
  const { id, title, image, tags, createdAt } = blog;
  return (
    <>
      <div className="card">
        <Link to={`/blogs/${id}`}>
          <img src={image} className="card-image" alt="" />
        </Link>
        <div className="p-4">
          <a
            href="post.html"
            className="text-lg post-title lws-RelatedPostTitle"
          >
            {title}
          </a>
          <div className="mb-0 tags">
            {tags.map((tag) => (
              <span key={tags.indexOf(tag)}>#{tag},</span>
            ))}
          </div>
          <p>{createdAt}</p>
        </div>
      </div>
    </>
  );
};

export default RelatedBlog;
